import React, { Component } from "react";

const PROMPT_KEY = "nova-install-prompt-seen";

class MobileInstallPrompt extends Component {
  state = { visible: false, installEvent: null, isIOS: false };

  componentDidMount() {
    const mobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || window.matchMedia("(max-width: 768px)").matches;
    const installed = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (!mobile || installed || window.localStorage.getItem(PROMPT_KEY)) return;

    this.setState({ visible: true, isIOS: /iPhone|iPad|iPod/i.test(navigator.userAgent) });
    window.addEventListener("beforeinstallprompt", this.captureInstallPrompt);
  }

  componentWillUnmount() { window.removeEventListener("beforeinstallprompt", this.captureInstallPrompt); }

  captureInstallPrompt = (event) => {
    event.preventDefault();
    this.setState({ installEvent: event });
  };

  dismiss = () => {
    window.localStorage.setItem(PROMPT_KEY, "1");
    this.setState({ visible: false });
  };

  install = async () => {
    if (this.state.installEvent) {
      await this.state.installEvent.prompt();
      await this.state.installEvent.userChoice;
      this.dismiss();
    }
  };

  render() {
    if (!this.state.visible) return null;
    const canInstall = Boolean(this.state.installEvent);
    return (
      <div className="nova-install-backdrop" role="dialog" aria-modal="true" aria-labelledby="install-title">
        <div className="nova-install-card">
          <div className="nova-install-glyph" aria-hidden="true"><img src="/nova-icon-192.png" alt="" /></div>
          <span className="nova-eyebrow">Faster mobile access</span>
          <h2 id="install-title">Save Nova Wallet as an app</h2>
          {this.state.isIOS ? (
            <p>Tap the <strong>Share</strong> button in your browser, then choose <strong>Add to Home Screen</strong>.</p>
          ) : canInstall ? (
            <p>Add Nova Wallet to your home screen for a cleaner, full-screen experience.</p>
          ) : (
            <p>Open your browser menu and choose <strong>Add to Home screen</strong> or <strong>Install app</strong>.</p>
          )}
          {canInstall && <button className="btn nova-primary-button" onClick={this.install}>Save as web app</button>}
          <button className="nova-install-later" onClick={this.dismiss}>Not now</button>
        </div>
      </div>
    );
  }
}

export default MobileInstallPrompt;
